import { Grid, Typography } from '@mui/material';
import React from 'react';
import { FeeTierTable } from './feeTierTable';

export function TieredFeeFields(): JSX.Element {
  return (
    <Grid item xs={12}>
      <Typography style={{ paddingBottom: '10px', alignSelf: 'flex-start' }}>
        Calculated daily based on portfolio balance within the tier range. Accepts either a rate or flat dollar amount. All values are annual and will be pro-rated for the billing period.
        <b> Please note that the $ or % Value for each tier is inclusive of GST.</b>
      </Typography>
      <FeeTierTable />
    </Grid>
  );
}
